export default __webpack_public_path__ + "static/media/ion_man-outline.ba5f89ea.svg";